import React from 'react';
import { RadioButtonGroup} from 'material-ui/RadioButton';

export default props =>
  <RadioButtonGroup
    {...props.inputProps}
    {...props.input}
    valueSelected={props.input.value}
    errorText={props.meta.touched && props.meta.error && props.meta.error}
  >
    {props.children}
  </RadioButtonGroup>;



// WEBPACK FOOTER //
// src/modules/forms/components/RadioButtonGroupField.js